import { logger } from 'functions/logger/logger'
import { Notifications } from 'library/constants'

export const checkRegEx = (n: string, regex: any) => {
  return (
    regex.reg.test(n) ||
    n === '' ||
    (() => {
      logger.log(regex.errorMsg)
      return false
    })()
  )
}
export const checkMaxMin = (
  n: string,
  max: string,
  min: string,
  handleNotification: any,
  currency?: string,
  toFix?: number,
  isZero?: boolean,
) => {
  if (isZero) {
    if (+n < +min || n === '') {
      handleNotification(
        Notifications.minStake +
        (+min).toFixed(toFix) +
        ' ' +
        currency +
        '. otherwise it will equal to 0.00 ' +
        currency,
      )
      return '0'
    }
  }
  if ((+n < +min || n === '') && !isZero) {
    handleNotification(
      Notifications.minStake + (+min).toFixed(toFix) + ' ' + currency,
    )
    return min
  } else if (+n > +max) {
    handleNotification(
      Notifications.maxStake + (+max).toFixed(toFix) + ' ' + currency,
    )
    return max
  } else {
    return n.toString().replace(/,/g, '.')
  }
}
export const checkOnlyDot = (str: any): boolean => {
  return (str[0] === '.' && str.length === 1) || (str[0] === ',' && str.length === 1)
}

export const checkStartWithZeros = (str: any): string => {
  if (str[0] === '0' && str[1] !== '.' && str[1] === '0') {
    const q: string = '' + str.slice(1, str.length)
    return checkStartWithZeros(q)
  } else {
    return str
  }
}
export const checkForEmpty = (str: any): boolean => str.length === 0
// || str === '0'

export const checkForLengthAfterDot = (n: string, toFix: any) => {
  if (n.indexOf('.') !== -1) {
    if (n.split('.')[1].length <= toFix) {
      return true
    }
    return false
  }
  return true
}

// const checkForLength = (n: srting) => {
//   if (n.length > maxLength) {
//     n.length = maxLength
//   }
// }
// const checkStartWithDot = (n: srtring) => {
//   if (n[0] === '.') n = '0' + n
// }
